import React from 'react';
import BCMSRegistry from "../BCMSRegistry/main.jsx";
import BCMSStateManager from '../BCMSStateManager/main.jsx';
import BCMSDisabledPrompt from '../BCMSDisabledPrompt/main.jsx';
import { useLocation, BCMSRouteData } from "../BCMSNav/main.jsx";
import { useModel } from "../../index.jsx";

export default function BCMSPage({ isActive, className, children, state, controller }) {
  const path = useLocation().pathname.slice(1);
  const model = useModel();
  const course = model.settings.courseTitle;

  if(model.env == "production"){
    var xhttp = new XMLHttpRequest(),
        url = location.protocol + '//' + location.hostname + '/track.php';
  
    url += '?Page=' + path
        + '&Camp=' + course + " (Click-Thru)"
        + '&b=' + (model.b ?? "")
        + '&referer=' + (document.referer ?? "");

    xhttp.open('GET', url, true);
    xhttp.send();
  }

  return (
    <BCMSStateManager state={ state ?? {} } controller={ controller ?? function(){} }>
      <BCMSRegistry isActive={ isActive ?? true }>
        <BCMSRouteData>
          <div className={ className ?? "" }>
            { children }
          </div>
        </BCMSRouteData>
      </BCMSRegistry>
    </BCMSStateManager>
  );
}
